<template>
  <div class="d-flex flex-column flex-fill white pb-5">
    <h1 class="text-center">Recibo de Sangria de Caixa</h1>
    <h4 class="text-center my-5">Fisiopower</h4>
    <div class="d-flex justify-center my-5">
      <table>
        <tr>
          <th>Data e Hora</th>
          <td>{{ wd.date | moment("DD/MM/YYYY HH:mm:ss") }}</td>
        </tr>
        <tr>
          <th>Nº Caixa</th>
          <td>{{ wd.id_box }}</td>
        </tr>
        <tr>
          <th>Valor do Refor.</th>
          <td>R$ {{ wd.value | money }}</td>
        </tr>
        <tr>
          <th colspan="2">Descrição</th>
        </tr>
        <tr>
          <td class="description" colspan="2">
            {{ wd.description }}
          </td>
        </tr>
        <tr>
          <th>Vendedor</th>
          <td>{{ wd.seller.first_name }}</td>
        </tr>
      </table>
    </div>
    <div class="signature mt-15">
      <span>{{ wd.seller.first_name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Withdraw",
  data() {
    return {
      wd: null,
    };
  },
  beforeMount() {
    this.wd = this.wdSession;
    if (!this.wdSession) this.$router.push({ name: "WithdrawBox" });
  },
  computed: {
    wdSession() {
      const wd = sessionStorage.getItem("transfer");
      sessionStorage.removeItem("transfer");
      return JSON.parse(wd);
    },
  },
};
</script>

<style scoped>
table {
  width: 300px;
}
th {
  width: 120px;
}
td {
  text-align: right;
}
table,
th,
td {
  border-spacing: 0;
  border: 1px solid #333;
}
td.description {
  padding: 3px;
  height: 70px;
  text-align: left;
  vertical-align: top;
}
.signature {
  display: flex;
  justify-content: center;
  text-align: center;
}

.signature span {
  width: 300px;
  border-top: 1px solid #000;
}
</style>
